module.exports = __webpack_public_path__ + "img/icon-ny-4.17b63361.svg";